<template>
    <Modal v-if="visible" :allowClose="false" @modal:close="handleClose()">
        <template #body>
            <div class="won-delete-red text-2xl font-semibold">{{ title }}</div>
            <div class="mt-2.5 won-blue text-sm">{{ subtitle }}</div>
        </template>
        <template #actions>
            <div class="flex items-center justify-end w-full">
                <won-button ghost :isDisabled="loading" class="w-28 mr-6 relative hover:border-won-red hover:bg-won-red hover:text-white confirm-delete-btn" @click="handleDelete">
                    <div v-if="loading" class="inset-y-0 left-0 flex items-center absolute ml-3.5">
                        <svg class="animate-spin absolute -ml-1 mr-3 h-4 w-4 won-color-nav-gray" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                    Delete
                </won-button>
                <won-button class="w-28" @click="handleClose">
                    Cancel
                </won-button>
            </div>
        </template>
    </Modal>
</template>

<script setup>
import Modal from "../components/modal.vue";
import WonButton from "../components/won-button.vue";

import { onMounted, toRefs } from 'vue'

const props = defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "",
    },
    subtitle: {
        type: String,
        default: "",
    },
    loading: {
        type: Boolean,
        default: false,
    },
})

const { visible } = toRefs(props)
const emit = defineEmits(["delete-modal:close", "delete-modal:confirm"])

onMounted(() => {
    document.onkeydown = function(e) {
        if(e.key == 'Escape' && visible.value) {
            handleClose()
        }
    }
})

const handleClose = () => {
    emit("delete-modal:close");
}

const handleDelete = () => {
    emit("delete-modal:confirm");
}
</script>
